import { Observable, defer, throwError } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';

/**
 * Add a performance measurement to the lifecycle of an `Observable`.
 * Source: https://lookout.dev/rules/measure-rxjs-observable-performance
 * @param nativeWindow The native `Window` object
 * @param name Name of the performance measurement
 * @param prefix Optional prefix for the name of the performance measurement
 * @returns 
 */
export const measure = function <T>(
    nativeWindow: Window,
    name: string,
    prefix = "app:"
) {
    return (source: Observable<T>) => {
        if(
            "performance" in nativeWindow &&
            nativeWindow.performance !== undefined
        ) {
            return defer(() => {
                nativeWindow.performance.mark(`${prefix}${name}:subscribe`);
                return source.pipe(
                    tap(() => nativeWindow.performance.mark(`${prefix}${name}:next`)),
                    catchError((error) => {
                        nativeWindow.performance.mark(`${prefix}${name}:error`);
                        return throwError(error);
                    }),
                    finalize(() => {
                        nativeWindow.performance.mark(`${prefix}${name}:complete`);
                        nativeWindow.performance.measure(
                            `${prefix}${name}`,
                            `${prefix}${name}:subscribe`,
                            `${prefix}${name}:complete`
                        );
                    })
                );
            });
        }
        return source;
    };
};
